export default __webpack_public_path__ + "static/media/lamata-logo.69ad2ec0.png";